import '../css/topHeader.css';
import '../css/sidenav.css';
import '../css/header.css';
import logo from '../images/weokasmain.svg';
import bell from '../images/headericon/Notification1.svg';
import bell2 from '../images/headericon/Notification2.svg';
import logout from '../images/logout.svg';
import logoutGrey from '../images/logout-grey.svg';
import User from '../images/headericon/User.svg';
import Search from '../images/headericon/Search.svg';
import React, { Component } from 'react';
import { createBrowserHistory } from 'history';  // ✅ Correct
import '../css/sidenav.css';
import { FaAngleUp, FaAngleDown } from 'react-icons/fa';
import Support from '../images/headericon/Support.svg';
import SupportWhite from '../images/headericon/SupportWhite.svg';
import DashboardWhite from '../images/sidebar/DashboardWhite.svg';
import DashboardGray from '../images/sidebar/DashboardGray.svg';
import OfficeLocationWhite from '../images/sidebar/OfficeLocationWhite.svg';
import OfficeLocationGray from '../images/sidebar/OfficeLocationGray.svg';
import ProjectManagerWhite from '../images/sidebar/ProjectManagerWhite.svg';
import ProjectManagerGray from '../images/sidebar/ProjectManagerGray.svg';
import RegisterdOkasBoxWhite from '../images/sidebar/RegisterdOkasBoxWhite.svg';
import RegisterdOkasBoxGray from '../images/sidebar/RegisterdOkasBoxGray.svg';
import mlWhite from '../images/sidebar/mlWhite.svg';
import mlGray from '../images/sidebar/mlGray.svg';
import ProjectDetailWhite from '../images/sidebar/ProjectDetailWhite.svg';
import ProjectDetailGray from '../images/sidebar/ProjectDetailGray.svg';
import HelpWhite from '../images/sidebar/HelpWhite.svg';
import HelpGray from '../images/sidebar/HelpGray.svg';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import SnackBar from '../containers/SnackBar';
import user from '../images/user.png'
import TextField from "@mui/material/TextField";
import UserWhite from "../images/user_white.png";
import UserGray from "../images/user_fade_color.png";
import MarketpaceWhite from "../images/marketSpace_white.png";
import MarketSpaceGray from "../images/marketSpace_gray.png";
import RoleWhite from "../images/role_white.png";
import RoleGray from "../images/role_gray.png";


const sidelogoimage = {
    backgroundImage: "url(" + require('../images/okasLogo.png') + ")",
    backgroundPosition: 'left 14px bottom 26px',

    // backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
};

class TopHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            profilePicture: null,
            listOpen: false,
            notilistOpen: false,
            showAll: false,
            notifications: [],
            noticount1: 0,
            noticount: 0,
            pmData: [],
            statusData: [],
            reason: '',
            opensearch: 0,
            showmodels2: false,
            showmodels3: false,
            showmodels4: false,
            showmodels5: false,
            showmodels6: false,
            showmodels7: false,
            selectedProject: [],
            dummyData: [
                "Element 1",
                "Element 2",
                "Element 3",
                "Element 4"
            ],
            selected: "dashboard",
            floorList: "collapse",
            showSome: true,
            usertype: localStorage.getItem('usertype'),
            okasVersionApidata: [],
            checkuserApidata: [],
            snackbarActive: false,
            snackbarMessage: '',
            showMenuSmallDevices: false,
            showFullScreenNavbar: false
        }
    }


    okasVersionApi = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/okasVersionApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasVersionApidata => {
                this.setState({
                    okasVersionApidata,
                    actualdata: okasVersionApidata
                }, () => {
                    this.renderokasVersionApi();
                    // console.log(this.state.okasVersionApidata)

                })
            })
    }

    renderokasVersionApi = () => {
        let xx = this.state.okasVersionApidata.map((e, index) => {
            return (
                <span key={index}>
                    {e.Application_Version}
                </span>
            )
        });
        return xx;
    }

    checkuserApi = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/userCheckApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(checkuserApidata => {
                this.setState({
                    checkuserApidata,
                    actualdata: checkuserApidata,
                    permissions: checkuserApidata.permissions,
                    source: checkuserApidata.source
                }, () => {
                    // console.log(this.props);
                    this.props.setPermssions(checkuserApidata.permissions);

                    this.props.userNameStyleActivate(this.state.checkuserApidata.user_name)
                    this.props.reuserNameStyleActivate(this.state.checkuserApidata.first_name)
                    this.props.userTypeStyleActivate(this.state.checkuserApidata.User_Type)
                    //    console.log(this.props)
                    if (this.state.checkuserApidata.status !== '200') {
                        localStorage.removeItem('auth');
                        // this.props.history.push('/login') 
                        window.location = "/login/session-timeout";
                    } else {
                        this.getallnotification();
                        this.okasVersionApi();
                        this.fetchNotifications();

                    }
                })
            })
    }

    handleDivClick = (item) => {
        // console.log("Item clicked:", item);
        this.setState({
            selectedProject: item,
            showmodels2: true
        });
    };

    handleReajectReasonClick = () => {
        // console.log("Item clicked:", item);
        this.setState({
            // selectedProject: item,
            showmodels4: true
        });
    };


    handleAcceptDivClick = (item) => {
        this.setState({
            selectedProject: item,
            showmodels6: true,     // Open the modal
            closing: false         // Modal is not closing
        });

        setTimeout(() => {
            this.setState({ closing: true });  // Start the fade-out animation
            setTimeout(() => {
                this.setState({ showmodels6: false, closing: false });  // After animation ends, hide modal
            }, 500);  // Match this duration with the CSS transition duration
        }, 1000);  // The delay before closing
    };



    handleRejectDivClick = (item) => {
        // When an item is clicked, set the selected project and open the modal
        this.setState({
            selectedProject: item,
            showmodels7: true,    // Show the modal
            closingRejectModal: false // Reset the closing state
        });

        setTimeout(() => {
            this.setState({ closingRejectModal: true });  // Trigger the closing animation
            setTimeout(() => {
                this.setState({ showmodels7: false, closingRejectModal: false });  // After animation ends, hide the modal
            }, 500);  // Match this duration with the CSS transition time (500ms)
        }, 1000);  // Delay before triggering the close action
    };


    // --------------------------------------------------------close model function start----------------------------
    onclosemodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels2: false,
        })
        window.location.reload();
    }
    // --------------------------------------------------------close model function End----------------------------


    componentDidMount() {

        this.fetchNotifications();
        // this.intervalId = setInterval(this.fetchNotifications, 10000);

    }


    fetchNotifications() {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch('/we/we/projectTransferRequest/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(data => {
                // const pmData = Array.isArray(data) ? data : [];
                this.setState({
                    pmData: data,
                    noticount1: data.length,
                }, () => {
                    this.renderTableDataPM();
                    // console.log('notification rajat data', this.state.pmData);
                })
            })
            .catch(error => console.error('Error fetching notifications:', error));
    }

    renderTableDataPM = () => {
        const { pmData } = this.state;
        const initialItemsToShow = 3;
        const { showAll } = this.state;


        // let visibleItems = pmData.slice(0, initialItemsToShow);
        if (!Array.isArray(pmData)) {
            return null;
        }

        let visibleItems = pmData.slice(0, initialItemsToShow);


        if (showAll) {
            visibleItems = pmData;
        }

        return visibleItems.map((e, index) => (
            <span key={index}>
                <div onClick={() => {
                    if (e.status === "pending") {
                        this.handleDivClick(e);

                    } else if (e.status === "Rejected") {
                        this.handleRejectDivClick(e);
                    } else {
                        this.handleAcceptDivClick(e);
                    }
                }}
                    style={{ display: 'flex', cursor: 'pointer', borderBottom: '1.5px solid #88abd1', justifyContent: 'center', alignItems: 'center', }}>
                    <img style={{
                        height: 'auto', weight: '100%', borderRadius: '50px', padding: '10px',
                        backgroundColor: 'white'
                    }} src={User} alt='userImage'></img>

                    {/* <p style={{ height: '40px', fontSize: '12px', marginTop: '5px', textAlign: 'start' }}>{e.building_name} handed over to you by {e.si_name}</p> */}

                    {e.status === "Rejected" && (
                        <p style={{ height: '40px', fontSize: '12px', marginTop: '5px', textAlign: 'start' }}>
                            {e.building_name} has been rejected by {e.assignee_pm_name}
                        </p>
                    )}
                    {e.status === "pending" && (
                        <p style={{ height: '40px', fontSize: '12px', marginTop: '5px', textAlign: 'start' }}>
                            {e.building_name} handed over to you by {e.si_name}
                        </p>
                    )}
                    {e.status === "Accepted" && (
                        <p style={{ height: '40px', fontSize: '12px', marginTop: '5px', textAlign: 'start' }}>
                            {e.building_name} has been accepted by {e.assignee_pm_name}
                        </p>
                    )}
                </div>
            </span>
        ));
    }

    getallnotification() {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/notificationApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {
                this.setState({
                    okasBoxData: okasBoxData,
                    noticount: okasBoxData.length,

                }, () => {
                    this.renderTableData();
                    // console.log('notification', this.state.okasBoxData);

                })
            })
    }


    renderTableData = () => {
        if (this.state.okasBoxData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            this.props.history.push('/login')
        }
        var typee = 0;
        let xx = this.state.okasBoxData.map((e, index) => {
            return (
                <div key={index} className="notilist" onClick={this.opennotipage.bind(this, e.id, e.module_id)}>
                    <div class="popover-content">
                        <div class="notification-messages">
                            <div class="message-wrapper">
                                <div class="description">
                                    {e.message}
                                </div>
                                <div class="date pull-left">
                                    {/* {e.created_at} */}
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            )
        });
        return xx;
    }


    reasonHandleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleAccept = (selectedProject) => {
        const { reason } = this.state;
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };
        console.log("Reason to be sent:", reason);  // Log the reason to the console

        fetch(`/we/we/projectTransferAccept/?building_id=${selectedProject.building_id}`, {
            method: "PUT",
            headers: headers,
            //   body: JSON.stringify({reason})
        })
            // .then(response => response.json())
            .then(response => {
                console.log('Response:', response);
                if (response.status === 200) {
                    this.setState({
                        // showmodels: '',
                        showmodels2: '',
                        showmodels3: true,
                    });

                    setTimeout(() => {
                        this.setState({ showmodels3: false });
                        window.location.reload();
                    }, 3000);
                }
                return response.json();  // This returns a promise
            })
            .then(data => {
                var dataadded = "dataadded";
                localStorage.setItem("dataadded", dataadded);
                // this.setState({ showmodels2: true });
            })

            .catch(error => {
                console.error('Error:', error);
            });
    };


    handleReject = (selectedProject) => {
        const { reason } = this.state;
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };
        // console.log("Reason to be sent:", reason);

        fetch(`/we/we/projectTransferReject/?building_id=${selectedProject.building_id}`, {
            method: "PUT",
            headers: headers,
            body: JSON.stringify({ reason })
        })
            // .then(response => response.json())
            .then(response => {
                // console.log('Response:', response);
                if (response.status === 200) {
                    this.setState({
                        // showmodels: '',
                        showmodels4: '',
                        showmodels5: true,
                    });

                    setTimeout(() => {
                        this.setState({ showmodels5: false });
                        window.location.reload();
                    }, 3000);
                }
                return response.json();
            })
            .then(data => {
                // console.log("Response rejected data put:", data);
                var dataadded = "dataadded";
                localStorage.setItem("dataadded", dataadded);
                // this.setState({ showmodels2: true });
            })

            .catch(error => {
                console.error('Error:', error);
            });
    };

    opennotipage = (id, module_id) => {
        this.getallnotification();
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        let tt = { id };
        fetch('/we/we/readNotificationApi/', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(tt)
        })
            .then(response => {
                response.json();
                const history = createBrowserHistory({ forceRefresh: true });
                localStorage.setItem("ticketid", module_id);
                history.push('/chat');
                this.props.history.push('/chat')
            })
            .then(data => { })
    }

    componentWillReceiveProps(prevProps, nextProps) {
        // console.log(prevProps)
    }

    componentDidMount() {
        // let r = document.getElementById("root");
        // console.log(r)

    }


    componentWillMount() {


        this.checkuserApi();
        this.props.searchBarActivate(false)
        const history = createBrowserHistory();
        const location = history.location;
        if (localStorage.getItem('auth')) {
            if (this.props.redux.globalVar.userTypeStyle == 2) {
                if (
                    // location.pathname==='/regOkas' ||
                    location.pathname === '/projectdetail'
                    || location.pathname === '/support'
                    || location.pathname === '/chat'
                ) {

                } else {
                    // this.props.history.push('/projectdetail'); 

                }
            }
        } else {
            const history = createBrowserHistory({ forceRefresh: true });
            history.push('/login');
            this.props.history.push('/login')
        }



        if (window.innerWidth < 800) {
            this.setState({
                showSome: false,
            })
        }
        if (location.pathname === '/dashboard' || location.pathname === '/profile2' || location.pathname === "/notifications") {
            this.setState({
                selected: 'dashboard'
            })
        } else if (location.pathname === '/regOkas') {
            this.setState({
                selected: 'regOkas'
            })
        } else if (location.pathname === '/memberlicense') {
            this.setState({
                selected: 'memberlicense'
            })
        } else if (location.pathname === '/regOkasunassigned') {
            this.setState({
                selected: 'regOkas'
            })
        } else if (location.pathname === '/regOkasassigned') {
            this.setState({
                selected: 'regOkas'
            })
        } else if (location.pathname === '/projectdetail' || location.pathname === '/projectdetailadd' || location.pathname === '/projectdetailedit') {
            this.setState({
                selected: 'projectdetail'
            })
        }
        else if (location.pathname === '/notifications') {
            this.setState({
                selected: 'notifications'
            })
        }
        else if (location.pathname === '/projectmanager') {
            this.setState({
                selected: 'projectmanager'
            })
        } else if (location.pathname === '/officelocation') {
            this.setState({
                selected: 'officelocation'
            })
        } else if (location.pathname === '/support' || location.pathname === '/chat' || location.pathname === '/remote-access' || location.pathname === '/approve' ||
            /^\/support\/[^/]+$/.test(location.pathname) || // Matches /support/:id
            /^\/support\/remote-access\/[^/]+$/.test(location.pathname)) {
            this.setState({
                selected: 'support'
            })
        } else if (location.pathname === '/userpage2' || location.pathname === '/usertreechart2') {
            this.setState({
                selected: 'userpage'
            })
        } else if (location.pathname === '/roles2') {
            this.setState({
                selected: 'roles'
            })
        }
        else if (location.pathname === '/marketplace2') {
            this.setState({
                selected: 'marketplace'
            })
        }
        else if (location.pathname === '/help' || location.pathname === '/design-help') {
            this.setState({
                selected: 'help'
            })
        }
    }

    setSelected = (selected) => {
        if (!selected.includes("Element")) {
            this.setState({
                floorList: "collapse"
            })
        }
        this.setState({
            selected: selected
        })
    }

    toggleFloors = () => {
        this.setState(prevState => {
            if (prevState.floorList === "collapse") {
                this.setState({
                    floorList: "collapse show"
                })
            }
            else {
                this.setState({
                    floorList: "collapse"
                })
            }
        })
    }
    openNav = () => {
        this.setState({
            showSome: !this.state.showSome
        })
    }

    redirectPage = (page) => {
        // const history = createBrowserHistory({forceRefresh: true});  
        // history.push(page); 
    }

    toggleShowAll = () => {

        this.setState(prevState => ({
            showAll: !prevState.showAll,
            // noticount1: 0 

        }));
    }

    toggleList() {
        this.setState(prevState => ({
            listOpen: !prevState.listOpen
        }));
    }

    togglenoti = () => {
        this.setState(prevState => ({
            notilistOpen: !prevState.notilistOpen
        }));
    }

    componentDidMount() {
        this.getProfileData();
        this.resetLogoutTimer();
        window.addEventListener("mousemove", this.resetLogoutTimer);
        window.addEventListener("keydown", this.resetLogoutTimer);
    }

    componentWillUnmount() {
        window.removeEventListener("mousemove", this.resetLogoutTimer);
        window.removeEventListener("keydown", this.resetLogoutTimer);
        clearTimeout(this.logoutTimer);
    }

    resetLogoutTimer = () => {
        clearTimeout(this.logoutTimer);
        this.logoutTimer = setTimeout(() => {
            this.handleLogout();  // Call logout function after 5 minutes of inactivity
        }, 5 * 60 * 1000); // 3 minutes
    };

    handleLogout = () => {
        fetch('/we/we/api/logoutview', {
            method: "GET",
            headers: {
                'X-CSRFToken': localStorage.getItem('csrftoken')
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.message === "success") {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.replace("/login");
                } else {
                    window.location = "/login/session-timeout";
                }
            })
            .catch(error => {
                alert("Something went wrong while logging out. Please try again.");
            });
    };



    onSearchClick = () => {

        this.props.searchBarActivate(!this.props.redux.globalVar.searchBarShow)
    }

    showMenuSmallDevices = () => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showMenuSmallDevices: !this.state.showMenuSmallDevices
        })
    }


    getProfileData = () => {
        // Set the loader to true while the request is processing
        this.setState({
            loader: true,
        });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        };

        // Example API endpoint for fetching the profile data
        fetch('/we/upload_image/', {
            method: 'GET',
            headers: headers, // Use the headers with token and CSRF token
        })
            .then(response => {
                if (!response.ok) {
                    // If the response status is not OK, throw an error
                    throw new Error('Error fetching profile data: ' + response.statusText);
                }
                return response.json(); // Parse the response as JSON
            })
            .then(data => {
                // Handle success (e.g., store data in state)
                //console.log("Profile data fetched:", data[0].image);
                this.setState({
                    profilePicture: data[0].image, // Assuming the response has this field
                    //fullName: data.fullName, // Assuming the response has this field
                    email: data.email, // Assuming the response has this field
                });
            })
            .catch(error => {
                // Handle error (e.g., show an error message)
                console.error("Error fetching profile data:", error);
            })
            .finally(() => {
                // Stop the loader after the request finishes
                this.setState({
                    loader: false,
                });
            });
    };

    render() {
        const { selectedProject } = this.state;
        return (
            <div >
                {this.state.showMenuSmallDevices ? <div className="header-menubar-active-background" onClick={() => {
                    // console.log("sd")
                    this.showMenuSmallDevices()
                }}></div> : null}
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />


                {/* //////////////////////////////////////start side bar///////////////////////////////////////////  */}
                {true ?
                    <div
                        className={this.state.showMenuSmallDevices ? "sidenav pull-left custom-width-menubar" : "sidenav pull-left hidden-xs hidden-sm hide-md-landscape"}
                        style={sidelogoimage}
                    >
                        {this.props.redux.globalVar.userTypeStyle ? (
                            <ul>
                                {this.props.redux.globalVar.userTypeStyle === '2' ? (
                                    <span>
                                        <li>
                                            <a
                                                href="/projectdetail"
                                                className={this.state.selected === "projectdetail" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('projectdetail');
                                                    this.setSelected("projectdetail");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'projectdetail' ? <img src={ProjectDetailWhite} /> : <img src={ProjectDetailGray} />}
                                                    <span>Project Detail</span>
                                                </div>
                                            </a>
                                        </li>
                                        {/* <li>
                                            <a
                                                href="/support"
                                                className={this.state.selected === "support" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('support');
                                                    this.setSelected("support");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'support' ? <img src={SupportWhite} /> : <img src={Support} />}
                                                    <span>Support</span>
                                                </div>
                                            </a>
                                        </li> */}
                                    </span>
                                ) : this.props.redux.globalVar.userTypeStyle === '4' ? (

                                    <span>
                                        {(this.state.permissions || []).map((permObj, idx) => {
                                            return Object.keys(permObj).map((moduleKey) => {

                                                // Determine the correct URL based on the condition
                                                let link = `/${moduleKey}`; // default
                                                const { source } = this.state;
                                                if (source === "SI") {
                                                    if (moduleKey === "support") link = "/support";
                                                    else if (moduleKey === "project manager") link = "/projectmanager";
                                                    else if (moduleKey === "inventory") link = "/regOkas";
                                                    else if (moduleKey === "user") link = "/userpage2";
                                                    else if (moduleKey === "role") link = "/roles2";
                                                    else if (moduleKey === "marketplace") link = "/marketplace2";
                                                    else if (moduleKey === "project detail") link = "/projectdetail";
                                                    else if (moduleKey === "office location") link = "/officelocation";
                                                } else if (source === "Distributor" && moduleKey === "support") {
                                                    link = "/support2";
                                                }

                                                // Normalize link for comparison (remove "/" and lowercase it)
                                                // const isSelected = this.state.selected === link.replace('/', '');
                                                // console.log(link);

                                                // ✅ Extract base key from the link
                                                const linkModuleKey = link.replace('/', '').replace(/[0-9]+$/, '');
                                                const isSelected = this.state.selected === linkModuleKey;


                                                return (
                                                    <li key={`${moduleKey}-${idx}`}>
                                                        {/* {console.log(moduleKey)} */}
                                                        <a
                                                            href={link} // Set the href dynamicall
                                                            className={isSelected ? "sidenav-button selected" : "sidenav-button"}
                                                            onClick={() => {
                                                                this.redirectPage(moduleKey);
                                                                this.setSelected(link.replace('/', '')); // store "officelocation", etc.
                                                            }}
                                                        >
                                                            <div className="menuLabel">
                                                                {(() => {


                                                                    if (link === "/support") {
                                                                        return isSelected ? <img src={SupportWhite} /> : <img src={Support} />;
                                                                    } else if (link === "/roles2") {
                                                                        return isSelected ? <img style={{ width: '15%' }} src={RoleWhite} /> : <img style={{ width: '15%' }} src={RoleGray} />;
                                                                    } else if (link === "/userpage2") {
                                                                        return isSelected ? <img style={{ width: '15%' }} src={UserWhite} /> : <img style={{ width: '15%' }} src={UserGray} />;
                                                                    } else if (link === "/regOkas") {
                                                                        return isSelected ? <img src={RegisterdOkasBoxWhite} /> : <img src={RegisterdOkasBoxGray} />;
                                                                    } else if (link === "/projectmanager") {
                                                                        return isSelected ? <img src={ProjectManagerWhite} /> : <img src={ProjectManagerGray} />;
                                                                    } else if (link === "/officelocation") {
                                                                        return isSelected ? <img src={OfficeLocationWhite} /> : <img src={OfficeLocationGray} />;
                                                                    } else if (link === "/projectdetail") {
                                                                        return isSelected ? <img src={ProjectDetailWhite} /> : <img src={ProjectDetailGray} />;
                                                                    } else {
                                                                        return null; // Optional: return a fallback image or nothing
                                                                    }
                                                                })()}
                                                                <span>{moduleKey.charAt(0).toUpperCase() + moduleKey.slice(1)}</span>
                                                            </div>
                                                        </a>
                                                    </li>
                                                );
                                            });
                                        })}
                                        <li>
                                            <a
                                                href="/help"
                                                className={this.state.selected === "help" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('help');
                                                    this.setSelected("help");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'help' ? <img src={HelpWhite} /> : <img src={HelpGray} />}
                                                    <span>Help</span>
                                                </div>
                                            </a>
                                        </li>
                                    </span>
                                ) : (
                                    <span>
                                        <li>
                                            <a
                                                href="/dashboard"
                                                className={this.state.selected === "dashboard" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('dashboard');
                                                    this.setSelected("dashboard");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'dashboard' ? <img src={DashboardWhite} /> : <img src={DashboardGray} />}
                                                    <span>Dashboard</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/regOkas"
                                                className={this.state.selected === "regOkas" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('regOkas');
                                                    this.setSelected("regOkas");
                                                }}
                                            >
                                                <div className="menuLabel" style={{ width: "100%" }}>
                                                    {this.state.selected === 'regOkas' ? <img src={RegisterdOkasBoxWhite} /> : <img src={RegisterdOkasBoxGray} />}
                                                    <span>OKAS Inventory</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/memberlicense"
                                                className={this.state.selected === "memberlicense" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('memberlicense');
                                                    this.setSelected("memberlicense");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'memberlicense' ? <img src={mlWhite} /> : <img src={mlGray} />}
                                                    <span>Member License</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/officelocation"
                                                className={this.state.selected === "officelocation" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('officelocation');
                                                    this.setSelected("officelocation");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'officelocation' ? <img src={OfficeLocationWhite} /> : <img src={OfficeLocationGray} />}
                                                    <span>Office Location</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/projectmanager"
                                                className={this.state.selected === "projectmanager" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('projectmanager');
                                                    this.setSelected("projectmanager");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'projectmanager' ? <img src={ProjectManagerWhite} /> : <img src={ProjectManagerGray} />}
                                                    <span>Project Manager</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/projectdetail"
                                                className={this.state.selected === "projectdetail" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('projectdetail');
                                                    this.setSelected("projectdetail");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'projectdetail' ? <img src={ProjectDetailWhite} /> : <img src={ProjectDetailGray} />}
                                                    <span>Project Detail</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/support"
                                                className={this.state.selected === "support" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('support');
                                                    this.setSelected("support");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'support' ? <img src={SupportWhite} /> : <img src={Support} />}
                                                    <span>Support</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/userpage2"
                                                className={this.state.selected === "userpage" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('userpage');
                                                    this.setSelected("userpage");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'userpage' ? <img style={{ width: '15%' }} src={UserWhite} /> : <img style={{ width: '15%' }} src={UserGray} />}
                                                    <span>Users</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/roles2"
                                                className={this.state.selected === "roles" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('roles');
                                                    this.setSelected("roles");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'roles' ? <img style={{ width: '15%' }} src={RoleWhite} /> : <img style={{ width: '15%' }} src={RoleGray} />}
                                                    <span>Roles</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/marketplace2"
                                                className={this.state.selected === "marketplace" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('marketplace');
                                                    this.setSelected("marketplace");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'marketplace' ? <img style={{ width: '16%' }} src={MarketpaceWhite} /> : <img style={{ width: '16%' }} src={MarketSpaceGray} />}
                                                    <span>Market Place</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/help"
                                                className={this.state.selected === "help" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => {
                                                    this.redirectPage('help');
                                                    this.setSelected("help");
                                                }}
                                            >
                                                <div className="menuLabel">
                                                    {this.state.selected === 'help' ? <img src={HelpWhite} /> : <img src={HelpGray} />}
                                                    <span>Help</span>
                                                </div>
                                            </a>
                                        </li>
                                    </span>
                                )}
                            </ul>
                        ) : null}
                    </div>

                    :
                    <div className="sidenav1">
                    </div>
                }
                {/* /////////////////////////////////////////////////////////sidebar//////////////////////////////*/}
                <div className="floatingTopHeader">
                    {true ? <div className="hidden-lg hidden-xs menu-hide-ipad-custom" style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        padding: "0 0px",
                        color: "#bcbccb",
                        margin: "auto 0 auto 10px",
                        paddingRight: "10px",
                        borderRight: "1px solid #BCBCCB",

                    }}
                        onClick={() => {
                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop)
                            this.showMenuSmallDevices()
                        }}
                    >
                        &#9776; Menu</div> : null}
                    <div className="leftSection">
                        {/* <a href={this.props.redux.globalVar.userTypeStyle == 2 ? "/projectdetail" : "/dashboard"}><img src={logo} /></a> */}
                        {/* <a
                            href={localStorage.getItem("name") === 2 ? "/projectdetail" : "/dashboard"}
                            onClick={(e) => {
                                if (localStorage.getItem("name") === 4) {
                                    e.preventDefault(); // Block the navigation
                                }
                            }}
                            style={{
                                pointerEvents: this.props.redux.globalVar.userTypeStyle === 4 ? 'none' : 'auto',
                                opacity: this.props.redux.globalVar.userTypeStyle === 4 ? 0.5 : 1,
                                cursor: this.props.redux.globalVar.userTypeStyle === 4 ? 'default' : 'pointer'
                            }}
                        >
                            <img src={logo} alt="Logo" />
                        </a> */}
                        <a
                            href={this.props.redux.globalVar.userTypeStyle == '2' ? "/projectdetail" : "/dashboard"}
                            onClick={(e) => {
                                if (this.props.redux.globalVar.userTypeStyle == '4') {
                                    e.preventDefault(); // ✅ This now correctly blocks navigation
                                }
                            }}
                            style={{
                                pointerEvents: this.props.redux.globalVar.userTypeStyle === 4 ? 'none' : 'auto',
                                opacity: this.props.redux.globalVar.userTypeStyle === 4 ? 0.5 : 1,
                                cursor: this.props.redux.globalVar.userTypeStyle === 4 ? 'default' : 'pointer',
                            }}
                        >
                            <img src={logo} alt="Logo"
                            />
                        </a>


                    </div>
                    <div className="rightSection" style={{ marginLeft: 'auto', position: 'relative' }}>
                        <div className="icons">

                            {/* Search    */}
                            {createBrowserHistory().location.pathname === '/dashboard' || createBrowserHistory().location.pathname === '/help' || createBrowserHistory().location.pathname === '/design-help' || createBrowserHistory().location.pathname === '/chat' ?
                                null
                                :
                                <a onClick={this.onSearchClick.bind(this)}>
                                    <img src={Search} className="hidden-xs hidden-sm" />
                                </a>
                            }
                            {/* <Link to="/support" className="hidden-xs" >
                                <img src={comments} />
                            </Link> */}
                            {/* {this.state.noticount1}      */}
                            {/* Accept Reaject start */}

                            {this.state.showmodels2 ?
                                <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{
                                    alignItems: 'center', display: 'flex',
                                    justifyContent: 'center',
                                }}>
                                    <div className="selfmodal-dialog"
                                        style={{
                                            width: this.props.windowWidth > 760 ? "50%" : "95%",
                                        }}
                                    >
                                        <div className="selfmodal-content" style={{
                                            marginTop: "100px",
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',

                                        }}>
                                            <div className="modal-header"   >
                                                <button type="button" className="close" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>&times;</button>

                                                <h3 style={{ textAlign: 'center', color: '#303c47' }}>Project Handover</h3>

                                                {selectedProject && (
                                                    <h4 style={{ textAlign: 'center', color: '#aaa', fontSize: '19px' }}>
                                                        {selectedProject.si_name} has handed over {selectedProject.building_name} to you! Do you want to accept it?
                                                    </h4>
                                                )}
                                                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
                                                    <div type="submit" className="btn btn-green allbtn"
                                                        onClick={() => this.handleAccept(selectedProject)}
                                                    >Accept</div>
                                                    <div type="submit" className="btn btn-red allbtn"
                                                        onClick={this.handleReajectReasonClick}
                                                    >Reject</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                : null}
                            {/* Accept Reaject form successfully end */}
                            {/* Accept  handover successfully start */}

                            {this.state.showmodels3 ?
                                <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{
                                    alignItems: 'center', display: 'flex',
                                    justifyContent: 'center',
                                }}>
                                    <div className="selfmodal-dialog"
                                        style={{
                                            width: this.props.windowWidth > 760 ? "50%" : "95%",


                                        }}
                                    >
                                        <div className="selfmodal-content" style={{
                                            marginTop: "100px",
                                            display: 'flex',
                                            alignItems: 'center', // Center vertically
                                            justifyContent: 'center', // Center horizontally

                                        }}>

                                            <div className="modal-header"  >
                                                {selectedProject && (
                                                    <h3 style={{ textAlign: 'center' }}>{selectedProject.building_name} handover has been accepted by you.</h3>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                : null}


                            {/* Accept handover successfully end */}

                            {/* Reaject reason modal  start */}

                            {this.state.showmodels4 ?
                                <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{
                                    alignItems: 'center', display: 'flex',
                                    justifyContent: 'center',
                                }}>
                                    <div className="selfmodal-dialog"
                                        style={{
                                            width: this.props.windowWidth > 760 ? "50%" : "95%",

                                        }}
                                    >
                                        <div className="selfmodal-content" style={{
                                            marginTop: "100px",
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',

                                        }}>

                                            <div className="modal-header" style={{ width: '100%' }}  >
                                                <button type="button" className="close" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>&times;</button>

                                                <h3 style={{ textAlign: 'center', width: '100%' }}>Mention Reason Of Rejection</h3>
                                                <br />

                                                <TextField style={{ width: '100%' }} label="Reason" type="text" name="reason" placeholder="Reason"
                                                    value={this.state.reason} onChange={this.reasonHandleChange}

                                                />


                                                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
                                                    <div type="submit" className="btn btn-blue allbtn"
                                                        onClick={() => this.handleReject(selectedProject)}

                                                    >Submit</div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                : null}


                            {/* Reaject reason modal  end */}

                            {/* Reaject  handover successfully start */}

                            {this.state.showmodels5 ?
                                <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{
                                    alignItems: 'center', display: 'flex',
                                    justifyContent: 'center',
                                }}>
                                    <div className="selfmodal-dialog"
                                        style={{
                                            width: this.props.windowWidth > 760 ? "50%" : "95%",


                                        }}
                                    >
                                        <div className="selfmodal-content" style={{
                                            marginTop: "100px",
                                            display: 'flex',
                                            alignItems: 'center', // Center vertically
                                            justifyContent: 'center', // Center horizontally

                                        }}>

                                            <div className="modal-header"  >

                                                <h3 style={{ textAlign: 'center' }}>{selectedProject.building_name} handover has been rejected by you.</h3>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                : null}


                            {/* Reaject handover successfully end */}

                            {/* Accepted handover project successfully by SI start */}

                            {this.state.showmodels6 ?
                                <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{
                                    alignItems: 'center', display: 'flex',
                                    justifyContent: 'center',
                                }}>
                                    <div
                                        className={`selfmodal-dialog ${this.state.closing ? "closing" : "open"}`}
                                        style={{
                                            width: this.props.windowWidth > 760 ? "50%" : "95%",
                                        }}
                                    >
                                        <div className="selfmodal-content" style={{
                                            marginTop: "100px",
                                            display: 'flex',
                                            alignItems: 'center', // Center vertically
                                            justifyContent: 'center', // Center horizontally

                                        }}>

                                            <div className="modal-header"  >
                                                {selectedProject && (
                                                    <h3 style={{ textAlign: 'center' }}>{selectedProject.building_name} has been accepted by {selectedProject.assignee_pm_name}</h3>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                : null}


                            {/* Accepted handover project successfully by SI end */}
                            {/* Rejected handover project successfully by SI start */}

                            {this.state.showmodels7 ?
                                <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false" style={{
                                    alignItems: 'center', display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                    <div className={`selfmodal-dialog ${this.state.closingRejectModal ? "closing" : "open"}`}
                                        style={{
                                            width: this.props.windowWidth > 760 ? "50%" : "95%",
                                        }}
                                    >
                                        <div className="selfmodal-content" style={{
                                            marginTop: "100px",
                                            display: 'flex',
                                            alignItems: 'center', // Center vertically
                                            justifyContent: 'center', // Center horizontally
                                        }}>
                                            <div className="modal-header"  >
                                                {selectedProject && (
                                                    <h3 style={{ textAlign: 'center' }}>{selectedProject.building_name} has been rejected by {selectedProject.assignee_pm_name} due to {selectedProject.reason}</h3>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                : null}


                            {/* Rejected handover project successfully by SI end */}
                            {/* Notification   */}
                            {/* <a data-toggle="dropdown">{this.state.noticount1 > 0 ? <img src={bell2} onClick={() => this.togglenoti()} /> : <img src={bell} onClick={() => this.togglenoti()} />}</a> */}
                            <a onClick={() => { this.togglenoti() }} >
                                {this.state.noticount1 > 0 ? <img src={bell2} alt="Notifications" /> : <img src={bell} alt="Notifications" />}
                            </a>
                            {this.state.notilistOpen && (
                                <span className={`custom-dropdown open`}>

                                    <h5 style={{
                                        textAlign: 'center',
                                        color: '#1d2b36',
                                        backgroundColor: '#e3f3ff',
                                        width: '100%',
                                        height: '35px',
                                        // border: '1px solid red',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>Notifications</h5>

                                    <div>

                                        {this.state.noticount1 > 0 ? this.renderTableDataPM() : 'No new Notification'}
                                        {this.state.noticount1 > 3 && (
                                            <button style={{ backgroundColor: 'transparent', border: 'none', marginTop: '8px', color: '#185ca0' }}
                                            // onClick={this.toggleShowAll}
                                            >
                                                {this.state.showAll ? <>Show Less <FaAngleUp /></> : <>
                                                    <a style={{ color: '#15599f' }}
                                                        href='/notifications'
                                                    >
                                                        See More<FaAngleDown />
                                                    </a>
                                                </>}
                                            </button>
                                        )}
                                    </div>
                                </span>
                            )}
                        </div>

                    </div>
                    <div className="rightSection">
                        {this.props.redux.globalVar.userTypeStyle === '1' ?
                            <React.Fragment>
                                <div id="myNav" class="overlay hidden-lg hidden-md hidden-sm"
                                    style={{
                                        display: this.state.showFullScreenNavbar ? "block" : "none"
                                    }}

                                >
                                    <a href="javascript:void(0)" class="closebtn"
                                        onClick={() => {

                                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop)
                                            this.setState({
                                                showFullScreenNavbar: !this.state.showFullScreenNavbar
                                            })
                                        }}>&times;</a>
                                    <div class="overlay-content">
                                        <a href="#">
                                            <a href="/dashboard" className={this.state.selected === "dashboard" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('dashboard'); this.setSelected("dashboard") }}><div className="menuLabel ">
                                                {this.state.selected == 'dashboard' ? <img src={DashboardWhite} /> : <img src={DashboardGray} />}
                                                <span>Dashboard</span></div></a>
                                        </a>
                                        <a href="#"><a href="/regOkas" className={this.state.selected === "regOkas" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('regOkas'); this.setSelected("regOkas") }}><div className="menuLabel" style={{ width: "100%" }}>
                                            {this.state.selected == 'regOkas' ? <img src={RegisterdOkasBoxWhite} /> : <img src={RegisterdOkasBoxGray} />}
                                            <span>OKAS Box Inventory</span>
                                        </div></a></a>
                                        <a href="#">
                                            <a href="/memberlicense" className={this.state.selected === "memberlicense" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('memberlicense'); this.setSelected("memberlicense") }}><div className="menuLabel">
                                                {this.state.selected == 'memberlicense' ? <img src={RegisterdOkasBoxWhite} /> : <img src={RegisterdOkasBoxGray} />}
                                                <span>Member License</span></div></a>
                                        </a>
                                        <a href="#"><a href="/officelocation" className={this.state.selected === "officelocation" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('officelocation'); this.setSelected("officelocation") }}><div className="menuLabel">
                                            {this.state.selected == 'officelocation' ? <img src={OfficeLocationWhite} /> : <img src={OfficeLocationGray} />}
                                            <span>Office Location</span></div></a></a>
                                        <a href="#"><a href="/projectmanager" className={this.state.selected === "projectmanager" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('projectmanager'); this.setSelected("projectmanager") }}><div className="menuLabel">
                                            {this.state.selected == 'projectmanager' ? <img src={ProjectManagerWhite} /> : <img src={ProjectManagerGray} />}
                                            <span>Project Manager</span></div></a></a>
                                        <a href="#"><a href="/projectdetail" className={this.state.selected === "projectdetail" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('projectdetail'); this.setSelected("projectdetail") }}><div className="menuLabel">
                                            {this.state.selected == 'projectdetail' ? <img src={ProjectDetailWhite} /> : <img src={ProjectDetailGray} />}
                                            <span>Project Detail</span></div></a></a>
                                        <a href="#">
                                            <a href="/help" className={this.state.selected === "help" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => { this.redirectPage('help'); this.setSelected("help") }}>
                                                <div className="menuLabel">
                                                    {this.state.selected == 'help' ? <img src={HelpWhite} /> : <img src={HelpGray} />}
                                                    <span>Help</span>
                                                </div>
                                            </a>
                                        </a>
                                        <a href="#" onClick={this.handleLogout} className="sidenav-button">
                                            <a className="sidenav-button" to="">
                                                <div className="menuLabel">
                                                    <img src={logoutGrey} />
                                                    <span>Logout</span>
                                                </div>
                                            </a>
                                        </a>
                                    </div>
                                </div> </React.Fragment> : <React.Fragment>
                                <div id="myNav" class="overlay hidden-lg hidden-md hidden-sm" style={{
                                    display: this.state.showFullScreenNavbar ? "block" : "none"
                                }} >
                                    <a href="javascript:void(0)" class="closebtn"
                                        onClick={() => {
                                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop)
                                            this.setState({
                                                showFullScreenNavbar: !this.state.showFullScreenNavbar
                                            })
                                        }}>&times;</a>
                                    <div class="overlay-content">
                                        <a href="#"><a href="/projectdetail" className={this.state.selected === "projectdetail" ? "sidenav-button selected" : "sidenav-button"} onClick={() => { this.redirectPage('projectdetail'); this.setSelected("projectdetail") }}><div className="menuLabel">
                                            {this.state.selected == 'projectdetail' ? <img src={ProjectDetailWhite} /> : <img src={ProjectDetailGray} />}
                                            <span>Project Detail</span></div></a></a>
                                        <a href="#">
                                            <a href="/help" className={this.state.selected === "help" ? "sidenav-button selected" : "sidenav-button"}
                                                onClick={() => { this.redirectPage('help'); this.setSelected("help") }}>
                                                <div className="menuLabel">
                                                    {this.state.selected == 'help' ? <img src={HelpWhite} /> : <img src={HelpGray} />}
                                                    <span>Help</span>
                                                </div>
                                            </a>
                                        </a>
                                        <a className="sidenav-button" href="#" onClick={this.handleLogout}>
                                            <a className="sidenav-button" >
                                                <div className="menuLabel">
                                                    <img src={logoutGrey} />
                                                    <span>Logout</span>
                                                </div>
                                            </a>
                                        </a>
                                    </div>
                                </div> </React.Fragment>
                        }
                        <div className="userDetails hidden-xs">
                            <div className="userIcon" onClick={() => this.toggleList()}>
                                <div className="userName  usernamedatas">
                                    {window.innerWidth < 801 ? null : this.props.redux.globalVar.reUserNameStyle}
                                    <img
                                        src={
                                            localStorage.getItem("name") === "2" || this.state.profilePicture == ""
                                                ? User
                                                : this.state.profilePicture
                                        }
                                        style={{
                                            height: '35px',
                                            width: '35px',
                                            borderRadius: '50%',
                                            objectFit: 'contain'
                                        }}
                                        className="usermarginleft"
                                        alt="User Profile"
                                    />


                                </div>
                                {this.state.listOpen && <span>
                                    <ul className="userMenu" style={{
                                        listStyle: "none",
                                        padding: "10px",
                                        margin: "0",
                                        background: "#f8f9fa",
                                        borderRadius: "8px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        width: "150px"
                                    }}>
                                        {this.props.redux.globalVar.userTypeStyle !== '2' && (
                                            <li
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "8px 12px",
                                                    cursor: "pointer",
                                                    borderBottom: "1px solid #ddd",
                                                    transition: "background 0.3s",
                                                    fontSize: "14px"
                                                }}
                                                onMouseEnter={(e) => e.target.style.background = "#e9ecef"}
                                                onMouseLeave={(e) => e.target.style.background = "transparent"}
                                            >
                                                <a
                                                    href="/profile2"
                                                    style={{
                                                        textDecoration: "none",
                                                        color: "inherit",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <img src={user} alt="Profile" style={{ width: "18px", marginRight: "8px" }} />
                                                    Profile
                                                </a>
                                            </li>
                                        )}
                                        <li
                                            onClick={this.handleLogout}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                transition: "background 0.3s",
                                                fontSize: "14px"
                                            }}
                                            onMouseEnter={(e) => e.target.style.background = "#e9ecef"}
                                            onMouseLeave={(e) => e.target.style.background = "transparent"}
                                        >
                                            <img src={logout} alt="Logout" style={{ width: "18px", marginRight: "8px" }} />
                                            Logout
                                        </li>
                                    </ul>

                                </span>}
                            </div>
                        </div>
                        <div className="usermarginleft visible-xs" onClick={() => {
                            this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop)
                            this.setState({
                                showFullScreenNavbar: !this.state.showFullScreenNavbar
                            })
                        }}> &#9776;</div>
                    </div>
                </div>
                {/*/////////////////support button/////////////////////////////////////////////// */}
                {/* {this.state.selected == 'dashboard' ? null :
                    <div className="supportpart pull-right">
                        <a>
                            {this.state.selected == 'support' || this.state.selected == 'chat' ?
                                <Link to="/dashboard" className="suptext" onClick={() => { this.redirectPage('dashboard'); this.setSelected("dashboard") }}><div><img src={DashboardGray} className="suptext" /> <span>DASHBOARD</span></div></Link>
                                :
                                <Link to="/support" className="suptext" onClick={() => { this.redirectPage('support'); this.setSelected("support") }}><div><img src={Support} className="suptext" /> <span>  SUPPORT</span></div></Link>
                            }
                        </a>
                    </div>
                } */}
                {/* /////////////////support button///////////////////////////////////////////////*/}


            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        userNameStyleActivate: (data) => dispatch({ type: ActionTypes.USERNAMESTYLE, data: data }),
        reuserNameStyleActivate: (data) => dispatch({ type: ActionTypes.REUSERNAMESTYLE, data: data }),
        userTypeStyleActivate: (data) => dispatch({ type: ActionTypes.USERTYPESTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),
        setPermssions: (data) => dispatch({ type: ActionTypes.PERMISSIONS, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(TopHeader);

